import React, { useEffect, useRef, useState } from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { refreshBuddyProfile } from '../../settings/buddySessionCache';

export default function WorkspaceHeader({ avatar, buddyId, avatarFallback = '🙂', title, subtitle, actions, accent = '#1F352A', badge = '' }) {
  const [avatarSrc, setAvatarSrc] = useState(avatar || '');
  const retriedAvatarRef = useRef('');

  useEffect(() => {
    setAvatarSrc(avatar || '');
    retriedAvatarRef.current = '';
  }, [avatar]);

  const recoverAvatar = async () => {
    if (!buddyId || retriedAvatarRef.current === avatarSrc) {
      setAvatarSrc('');
      return;
    }
    retriedAvatarRef.current = avatarSrc;
    setAvatarSrc('');
    try {
      const refreshed = await refreshBuddyProfile(buddyId);
      if (refreshed?.image) setAvatarSrc(refreshed.image);
    } catch {
      // Keep the reaction fallback visible when refresh is unavailable.
    }
  };

  return <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretch', sm: 'center' }} justifyContent="space-between" gap={1.5} sx={{ p: 2, borderBottom: '1px solid #D6DED2', bgcolor: '#fff' }}>
    <Stack direction="row" spacing={1.25} alignItems="center">
      {avatarSrc ? <Box component="img" src={avatarSrc} alt="" onError={recoverAvatar} sx={{ width: 44, height: 44, borderRadius: '50%', objectFit: 'cover', border: '1px solid #D6DED2' }} /> : <Box aria-hidden sx={{ width: 44, height: 44, borderRadius: '50%', bgcolor: '#E6EED1', display: 'grid', placeItems: 'center', fontSize: 24 }}>{avatarFallback}</Box>}
      <Box>
        <Stack direction="row" spacing={0.75} alignItems="center">
          <Typography sx={{ fontWeight: 800, color: accent }}>{title}</Typography>
          {badge && <Chip label={badge} size="small" color="warning" variant="outlined" sx={{ height: 20, fontSize: 11, fontWeight: 800 }} />}
        </Stack>
        {subtitle && <Typography variant="caption" color="text.secondary">{subtitle}</Typography>}
      </Box>
    </Stack>
    {actions && <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-end" flexWrap="wrap">{actions}</Stack>}
  </Stack>;
}
